<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="500px"
  >
    <div v-if="fromOrder">
      <v-card class="bg_juchu" height="350px">
        <v-card-title>
          <v-row justify="end">
            <v-btn
              icon
              @click.stop="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>

        <v-card-actions class="card-actions">
          <v-layout justify="end">
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              @click="imageClickEvent"
            >
              詳細はこちら　▶︎
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </div>
    <div v-else-if="fromRequest">
      <v-card class="bg_hachu" height="350px">
        <v-card-title>
          <v-row justify="end">
            <v-btn
              icon
              @click.stop="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>

        <v-card-actions class="card-actions">
          <v-layout justify="end">
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              @click="imageClickEvent"
            >
              詳細はこちら　▶︎
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </div>
    <div v-else-if="fromManifest">
      <v-card class="bg_mani" height="350px">
        <v-card-title>
          <v-row justify="end">
            <v-btn
              icon
              @click.stop="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>

        <v-card-actions class="card-actions">
          <v-layout justify="end">
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              @click="imageClickEvent"
            >
              詳細はこちら　▶︎
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </div>
    <div v-else>
      <v-card class="bg_report" height="350px">
        <v-card-title>
          <v-row justify="end">
            <v-btn
              icon
              @click.stop="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>

        <v-card-actions class="card-actions">
          <v-layout justify="end">
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              @click="imageClickEvent"
            >
              詳細はこちら　▶︎
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>

import {mapState} from 'vuex'

export default {
  name: 'EcContractSinglePlanGuideDialog',
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    fromOrder: {
      type: Boolean,
      default: () => false,
    },
    fromRequest: {
      type: Boolean,
      default: () => false,
    },
    fromManifest: {
      type: Boolean,
      default: () => false,
    },
    fromReport: {
      type: Boolean,
      default: () => false,
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    imageClickEvent () {
      window.open(process.env.VUE_APP_EC_CONTRACT_GRADEUP_GUIDE_URL, "_blank" )
    },
  }
}

</script>

<style scoped lang="scss">
  .bg_hachu {
    background-image: url("@/assets/images/upgrade_guides/bnr_denshi_jw_500x350.png");
  }
  .bg_juchu {
    background-image: url("@/assets/images/upgrade_guides/bnr_denshi_jw_500x350.png");
  }
  .bg_mani {
    background-image: url("@/assets/images/upgrade_guides/bnr_denshi_jw_500x350.png");
  }
  .bg_report {
    background-image: url("@/assets/images/upgrade_guides/bnr_gyousei2_500x350.png");
  }
  .card-actions {
    position: absolute;
    bottom: 25px;
    right: 5px;
  }
</style>